import React, { useState, useEffect, useContext } from 'react';
import UserContext from '../../components/User_Context.js';
import * as menu from "../../assets/menus/menu.js"
import { useTranslation } from 'react-i18next';
import { Organizational_Chart } from "../../components/ui/organizational_chart.js";
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import * as api from "../../api/apiConnector.js";
import waiting from "../../assets/images/waiting.svg";
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import * as utils from "../../components/utils.js";
import Undo_Redo from "../../components/ui/undo_redo.js";
import Choices from '../../components/Choices.js';


const Indicators_Screen = (params) => {
    const { currentUser } = useContext(UserContext);
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const [currentNode, setCurrentNode] = useState(null);
    const [draggingNode, setDraggingNode] = useState(null);
    const [droppingNode, setDroppingNode] = useState(null);
    const [requirements, setRequirements] = useState(null);
    const [viewMode, setViewMode] = useState("list");
    const [types, setTypes] = useState(null);
    const levelLabels = [
        t('scopeOfEvaluation', { ns: 'labels' }),
        t('pointOfAttention', { ns: 'labels' }),
        t('indicator', { ns: 'labels' })
    ];
    const [preventQuit, setPreventQuit] = useState(false);

    let undo_redo = null;

    //#region editing
    const _update = () => {
        setData(utils.clone(_renumber(data)));
        if (undo_redo) {
            undo_redo.push(data);
            setPreventQuit(true);
        }
    }

    const _renumber = (nodes, node, level) => {
        const _children = nodes.filter(x => x.ParentId == node?.Id && !x.Deleted)
            .sort((a, b) => { return a.ItemOrder - b.ItemOrder });

        for (var i = 0; i < _children.length; i++) {
            const _child = _children[i];
            if (_child.ItemOrder != i) {
                _child.ItemOrder = i;
                _child.__toUpdate = true;
            }
        }

        for (var c of _children) {
            _renumber(nodes, c, (level ?? 0) + 1);
        }

        return nodes;
    }

    const editModal = () => {
        const _validate = () => {
            if (!currentNode.Name) return false;
            return true;
        }

        const _localUpdate = () => {
            currentNode.__localUpdate = true;
            setCurrentNode(utils.clone(currentNode));
        }

        const _confirmEdit = () => {
            const _indexToUpdate = data.findIndex(x => x.Id == currentNode.Id);
            currentNode.__toUpdate = true;
            currentNode.__localUpdate = false;
            data[_indexToUpdate] = currentNode;
            _update();
            setCurrentNode(null);
        }


        if (currentNode) {
            return (
                <>
                    <div class="modal-backdrop fade show"></div>
                    <div id="business_unit_edit_modal" className="modal fade show" style={{ display: "block" }} >
                        <div className="modal-dialog modal-xl  modal-dialog-centered modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{currentNode.Name}</h5>
                                    <button type="button" className="btn-close" aria-label="Close"
                                        onClick={(e) => {
                                            setCurrentNode(null);
                                        }}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <label for="item_code" className="form-label">{t('code', { ns: 'labels' })}</label>
                                        <input id="item_code" type="text" className="form-control" value={currentNode.Code}
                                            onChange={(e) => {
                                                currentNode.Code = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('codeOfItem', { ns: 'labels' })} />
                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_description" className="form-label">{t('pointsOfAttention', { ns: 'labels' })}</label>
                                        {<Choices voc={requirements}
                                            dropDownParent={"business_unit_edit_modal"}
                                            value={"Id"} text={"Name"}
                                            selected={currentNode.Requirements ? requirements.filter(x => currentNode.Requirements.find(y => y.Id == x.Id)) : []}
                                            textDelegate={
                                                (item) => {
                                                    return `${item.Code} -  ${item.Name}`
                                                }
                                            }
                                            allowClear={true}
                                            multiple={true}
                                            onChange={(e) => {

                                                if (e.selected) {
                                                    currentNode.Requirements = e.selected;
                                                }
                                                else {
                                                    currentNode.Requirements = null;

                                                }

                                                _localUpdate();
                                            }
                                            }></Choices>}
                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_name" className="form-label">{t('indicator', { ns: 'labels' })}<span className="text-danger">*</span></label>
                                        <textarea id="item_name" type="text" rows="3" className="form-control" value={currentNode.Name}
                                            onChange={(e) => {
                                                currentNode.Name = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('nameOfItem', { ns: 'labels' })}></textarea>
                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_type" className="form-label">{t('type', { ns: 'labels' })}<span className="text-danger">*</span></label>
                                        <select id="item_type" className="form-select" value={currentNode.IndicatorType}
                                            onChange={(e) => {
                                                currentNode.IndicatorType = e.target.value;
                                                _localUpdate();
                                            }}
                                        >
                                            <option value="">N/A</option>
                                            <option value="qualitative">{t('qualitative', { ns: 'labels' })}</option>
                                            <option value="quantitative">{t('quantitative', { ns: 'labels' })}</option>
                                        </select>
                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_reference" className="form-label">{t('reference', { ns: 'labels' })}</label>
                                        <textarea id="item_reference" rows="3" className="form-control" value={currentNode.ReferenceName}
                                            onChange={(e) => {
                                                currentNode.ReferenceName = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('referenceOfItem', { ns: 'labels' })}></textarea>
                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_datasource" className="form-label">{t('dataSource', { ns: 'labels' })}</label>
                                        <textarea id="item_datasource" rows="3" className="form-control" value={currentNode.DataSourceDescription}
                                            onChange={(e) => {
                                                currentNode.DataSourceDescription = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('sourceOfItem', { ns: 'labels' })}></textarea>
                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_notes" className="form-label">{t('notes', { ns: 'labels' })}</label>
                                        <textarea id="item_notes" rows="5" className="form-control" value={currentNode.Notes}
                                            onChange={(e) => {
                                                currentNode.Notes = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('descriptionOfItem', { ns: 'labels' })}>

                                        </textarea>
                                    </div>
                                    <br></br>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary"
                                        onClick={(e) => {
                                            setCurrentNode(null);
                                        }}
                                    >{t('close', { ns: 'labels' })}</button>
                                    <button type="button" onClick={(e) => {
                                        _confirmEdit();
                                    }}
                                        className="btn btn-primary" disabled={_validate ? null : true}>{t('ok', { ns: 'labels' })}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else {
            return (null);
        }

    }

    const drawNode = (params) => {
        const { node, level = 0 } = params;

        const children = data.filter(x => x.ParentId == node.Id && !x.Deleted).sort((a, b) => { return a.ItemOrder - b.ItemOrder });
        const brothers = data.filter(x => x.ParentId == node.ParentId && !x.Deleted).sort((a, b) => { return a.ItemOrder - b.ItemOrder });
        const nodeIndex = brothers.findIndex(x => x === node);

        if (node.Deleted) {
            return (null);
        }
        else {
            return (
                <>
                    <tr data-id={node.Id} style={{}}>
                        <th scope="row">
                            {node.Code}
                        </th>
                        <td style={{ whiteSpace: "wrap" }}>
                            {
                                level < 3 ? (<h5 style={{ marginLeft: `${level * 3}em` }}>{node.Name}</h5>) : (
                                    <p style={{ marginLeft: `${level * 3}em` }}>{node.Name}</p>
                                )
                            }
                        </td>
                        <td>
                            <div>


                                <i style={{ cursor: 'pointer' }} data-bs-tooltip="tooltip" data-bs-placement='top' title={t('add', { ns: 'labels' })} onClick={async (e) => {
                                    _addNode(node);
                                }} className="fa-regular fa-square-plus me-4 fa-2x hover-icon-add" />

                                <i style={{ cursor: 'pointer', color: '#17a2b8' }} data-bs-tooltip="tooltip" data-bs-placement='top' title={t('edit', { ns: 'labels' })} onClick={(e) => {
                                    setCurrentNode(utils.clone(node));
                                }} className="fa-regular fa-pen-to-square me-4 fa-2x hover-icon-edit" />

                                <i style={{ cursor: 'pointer', color: '#dc3545' }} data-bs-tooltip="tooltip" data-bs-placement='top' title={t('delete', { ns: 'labels' })} onClick={(e) => {
                                    _deleteNode(node.Id);
                                }} className="fa fa-trash fa-2x hover-icon-trash me-4" />

                                {
                                    nodeIndex > 0 ? (<i style={{ cursor: 'pointer' }} data-bs-tooltip="tooltip" data-bs-placement='top' title={t('moveUp', { ns: 'labels' })} onClick={(e) => {
                                        const _tmp = brothers[nodeIndex].ItemOrder;
                                        brothers[nodeIndex].ItemOrder = brothers[nodeIndex - 1].ItemOrder;
                                        brothers[nodeIndex - 1].ItemOrder = _tmp;
                                        brothers[nodeIndex - 1].__toUpdate = true;
                                        _update();
                                    }} className="fa fa-arrow-up fa-2x hover-icon-edit me-4" />) : (null)
                                }

                                {
                                    nodeIndex < brothers.length - 1 ? (<i style={{ cursor: 'pointer' }} data-bs-tooltip="tooltip" data-bs-placement='top' title={t('moveDown', { ns: 'labels' })} onClick={(e) => {
                                        const _tmp = brothers[nodeIndex].ItemOrder;
                                        brothers[nodeIndex].ItemOrder = brothers[nodeIndex + 1].ItemOrder;
                                        brothers[nodeIndex + 1].ItemOrder = _tmp;
                                        brothers[nodeIndex + 1].__toUpdate = true;
                                        _update();
                                    }} className="fa fa-arrow-down fa-2x hover-icon-edit" />) : (null)
                                }
                            </div>
                        </td>
                    </tr>

                    {(children.length > 0) ? (<>
                        {children.map(x => drawNode({ node: x, level: level + 1 }))}
                    </>)
                        : (null)}
                </>
            )
        }

    }

    const _deleteNode = (id, level) => {
        const _node = data.find(x => x.Id == id);
        _node.Deleted = true;
        _node.__toUpdate = true;

        const _children = data.filter(x => x.ParentId == id);
        for (var c of _children) {
            _deleteNode(c.Id, (level || 0) + 1);
        }

        if (!level) {
            _update();
        }
    }

    const _getNewNode = async () => {
        const _node = (await api.sendMessage("admin/system/organization/getNewBusinessUnit", {
            user: currentUser()
        }))?.node;

        return _node;
    }

    const _addNode = async (node) => {
        const _node = await _getNewNode();
        const _childrenOrder = data.filter(x => x.ParentId == node.Id).map(x => x.ItemOrder);
        _node.ParentId = node.Id;
        _node.ItemOrder = _childrenOrder.length > 0 ? Math.max(_childrenOrder) : 0;
        _node.Name = t('newIndicator', { ns: 'labels' });
        _node.__toUpdate = true;
        _node.__localUpdate = false;
        data.push(_node);
        _update();
        setCurrentNode(utils.clone(_node));
    }

    const drawMainNode = () => {
        const levelOneNodes = data.filter(x => (x.ParentId == null) && !x.Deleted)
            .sort((a, b) => { return a.ItemOrder - b.ItemOrder })
            ?? [];
        return (
            <>
                <tr data-root-node="true" >
                    <td></td>
                    <td></td>
                    <td>
                        <div>
                            <i style={{ cursor: 'pointer' }} data-bs-tooltip="tooltip" data-bs-placement='top' title={t('add', { ns: 'labels' })} onClick={(e) => {
                                _addNode({ node: { Id: null } });
                            }} className="fa-regular fa-square-plus me-4 fa-2x hover-icon-add" />
                        </div>
                    </td>
                </tr>

                {(levelOneNodes.length > 0) ? (<>
                    {levelOneNodes.map(x => drawNode({ node: x, level: 1 }))}
                </>)
                    : (null)}
            </>
        )
    }
    //#endregion

    const setBreadCrumb = (params) => {
        var path = [{
            link: "/",
            name: t("menu.main")
        },
        {
            link: "/Indicators",
            name: t("menu.indicators")
        }
        ];
        breadcrumb.set(path);
    }


    const retrieveData = async () => {
        const result = (await api.sendMessage("admin/indicators/get_all", {
            user: currentUser(),
        }));

        var types = (await api.sendMessage("admin/vocs/get", {
            user: currentUser(),
            body: {
                voc_id: "requisites_main_contexts"
            }
        }))?.items ?? [];

        const _checkIndicatorsDepth = async (indicators) => {
            const levels = [];

            for (var i of indicators) {
                var realInd = i.Indicator;
                if (realInd.ParentId) {
                    if (!levels.find(x => x == realInd.ParentId)) {
                        levels.push(realInd.ParentId);
                    }
                }
            }

            if (levels.length < 2) {
                var newIndicatorsToAdd = {
                    Id: `rootLevel_${levels.length}`,
                    Indicator: {
                        Id: `rootLevel_${levels.length}`,
                        Name: `rootLevel_${levels.length}`

                    }
                };

                indicators.push(newIndicatorsToAdd);

                for (var i of indicators) {
                    if (i.Indicator.Id != newIndicatorsToAdd.Indicator.Id) {
                        if (!i.Indicator.ParentId) {
                            i.Indicator.ParentId = newIndicatorsToAdd.Indicator.Id;
                        }
                    }

                }
                await _checkIndicatorsDepth(indicators);
            } else {
                return levels.length;
            }


        }

        for (var type of types) {
            type.BusinessUnits = result.user_indicators.filter(x => x.Indicators.find(y => y.Requirements && y.Requirements.find(z => z.Requirement.RequirementContextCode == type.Code)));
            if (type.BusinessUnits.length > 0) {
                type.BusinessUnits[0].selected = true;
            }

            if (type.BusinessUnits.length > 0) {
                for (var bu of type.BusinessUnits) {
                    var checked = await _checkIndicatorsDepth(bu.Indicators);
                }
            }

        }







        setTypes(types);



        if (!result.success) {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: `${t('errorAccessingData', { ns: 'labels' })}: ${result?.message}`,
                allowOutsideClick: false
            });
            return;
        }


        setData(result.indicators);
        undo_redo.push(result.indicators);
    }

    const retrieveRequirements = async () => {
        const requirements = (await api.sendMessage("admin/requirements/get_all", {
            user: currentUser(),
        })).requirements;

        if (requirements) {
            requirements.sort((a, b) => {
                if (a.Code < b.Code) {
                    return -1;
                }
                if (a > b) {
                    return 1;
                }
                return 0;
            });
            setRequirements(requirements);
        }

    }

    useEffect(() => {
        (async () => {
            setBreadCrumb();
            menu.write({ user: currentUser() });
            await retrieveData();

            await retrieveRequirements();

        })();
    }, []);


     useEffect(() => {
            if(preventQuit){
                const handleBeforeUnload = (event) => {
    
                    event.preventDefault();
        
                    event.returnValue = '';
                };
        
                window.addEventListener('beforeunload', handleBeforeUnload);
        
                return () => {
                    window.removeEventListener('beforeunload', handleBeforeUnload);
                };
            }
        }, [preventQuit]);
    useEffect(() => {
        window.$("tr[data-id]").draggable({
            opacity: 0.7,
            cursor: "move",
            containement: "table",
            revert: "invalid",
            start: (e) => {
                window.$(e.target).css("z-index", 1000);
                setDraggingNode(data.find(x => x.Id == window.$(e.target).attr("data-id")));
            },
            stop: (e) => {
                window.$(e.target).css("z-index", 0);
                window.$("tr[data-id]").find("td").removeClass("table-primary");
            },
            axis: "y"
        });

        window.$("tr[data-id]").droppable({
            over: (e, ui) => {
                window.$(e.target).find("td").addClass("table-primary");
            },
            out: (e, ui) => {
                window.$(e.target).find("td").removeClass("table-primary");
            },
            drop: (e, ui) => {
                setDroppingNode(data.find(x => x.Id == window.$(e.target).attr("data-id")));
                ui.draggable.animate({ left: 0, top: 0 }, 500);
            }
        });

        window.$("tr[data-root-node]").droppable({
            drop: (e, ui) => {
                setDroppingNode({ Id: null });
                ui.draggable.animate({ left: 0, top: 0 }, 500);
            }
        });

        window.$("select[data-mode='business_unit_selector']").select2();
    }, [data, currentNode, viewMode, types]);

    const _getPath = (node) => {
        const output = [];
        let _current = node;
        while (_current) {
            output.push(_current);
            _current = data.find(x => x.Id == _current.ParentId);
        }

        return output.reverse();
    }

    const _getChildren = (node) => {
        const output = [node];
        const _children = data.filter(x => x.ParentId == node.Id);
        if (_children) {
            for (var c of _children) {
                const _subItems = _getChildren(c);
                output.push(..._subItems);
            }
        }

        return output;
    }

    useEffect(() => {
        if (draggingNode && droppingNode) {
            const _draggingPath = _getPath(draggingNode);
            const _forbidden = _getChildren(draggingNode).find(x => x.Id == droppingNode.Id);
            if (_forbidden) {

            }
            else {
                draggingNode.ParentId = droppingNode.Id;
            }
            _update();
        }
    }, [droppingNode]);

    const _toSave = () => {
        return data.filter(x => x.__toUpdate);
    }

    const _validate = () => {
        const errors = [];

        for (const d of data) {
            if (!d.Name) {
                var error = t('nameMissingForItem', { ns: 'labels' }, { index: data.findIndex(x => x === d) + 1 })
                errors.push(error);
            }
        }

        return errors;
    }

    const _save = async () => {
        const errors = _validate();

        withReactContent(Swal).fire({
            title: t('saving', { ns: 'labels' }),
            icon: "info",
            text: t('savingData', { ns: 'labels' }),
            allowOutsideClick: false
        });

        if (errors.length > 0) {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: errors.join(','),
                showConfirmButton: true
            });
        }
        else {
            const dataToUpdate = _toSave();

            if (dataToUpdate.length == 0) {
                withReactContent(Swal).fire({
                    title: t('dataJustUpdated', { ns: 'labels' }),
                    icon: "info",
                    text: t('noChangesAfterLastSave', { ns: 'labels' }),
                    showConfirmButton: true
                });
                return { success: false };
            }

            const result = await api.sendMessage("admin/indicators/save", {
                user: currentUser(),
                body: {
                    indicators: dataToUpdate
                }

            });

            if (result.success) {
                withReactContent(Swal).fire({
                    title: t('success', { ns: 'labels' }),
                    icon: "success",
                    text: t('indicatorsSavedWithSuccess', { ns: 'labels' }, { count: dataToUpdate.length }),
                    showConfirmButton: true
                });

                for (const d of data) {
                    d.__toUpdate = false;
                    setData(utils.clone(data));
                }

                return result;
            }
            else {
                withReactContent(Swal).fire({
                    title: t('error', { ns: 'labels' }),
                    icon: "error",
                    text: result.message,
                    showConfirmButton: true
                });

                return result;
            }
        }

    }

    const _drawChangeMode = () => {
        if (viewMode == "list") {
            return (
                <a className="me-3 position-relative text-primary fs-13" href="#"
                    onClick={(e) => {
                        setViewMode("edit");
                    }}
                    title={t('goToEditMode', { ns: 'labels' })}>
                    <i class="fa-solid fa-pen-to-square fa-2x"></i>
                </a>)
        } else if (viewMode == "edit") {
            return (
                <a className="me-3 position-relative text-primary fs-13" href="#"
                    onClick={(e) => {
                        setViewMode("list");
                    }}
                    title={t('goToListMode', { ns: 'labels' })}>

                    <i class="fa-solid fa-list fa-2x"></i>
                </a>)
        }

        return (null)

    }

    const _drawTabs = () => {



        for (let t of types) {
            for (let b of t.BusinessUnits) {
                for (var f of b.Indicators) {
                    f.level = 0;
                    let _current = f;
                    while (_current) {
                        f.level++;
                        _current = b.Indicators.find(x => x.Indicator.Id == _current.Indicator.ParentId);
                    }
                }
            }
        }

        if (types.length > 0) types[0].selected = true;

        const _drawTabHeader = (t) => {
            return (<li className="nav-item" role="presentation">
                <button className={`nav-link ${t.selected ? "active" : ""}`} id={`main-tab-${t.Code}`} data-bs-toggle="tab" data-bs-target={`#tab-content-${t.Code}`} type="button" role="tab" aria-controls={`#tab-content-${t.Code}`}
                    aria-selected={t.selected ? true : null}>{t.Name}</button>
            </li>);
        }



        const _drawTabDiv = (t) => {
            const _businessUnit = t.BusinessUnits.find(x => x.selected);


            const _rootNodes = _businessUnit ? _businessUnit.Indicators.filter(x => x.level == 1).sort((a, b) => { return a.Indicator.ItemOrder - b.Indicator.ItemOrder }) : [];
            const _countChildren = (f) => {
                const _children = _businessUnit.Indicators.filter(x => x.Indicator.ParentId == f.Indicator.Id);
                f._childrenCount = _children.length;
                for (const c of _children) {
                    f._childrenCount += _countChildren(c);
                }

                return f._childrenCount;
            }

            const _countMaxLevel = (f, level) => {
                const _children = _businessUnit.Indicators.filter(x => x.Indicator.ParentId == f.Indicator.Id);
                f._childrenMaxLevel = level || 1;
                f._level = level || 1;
                for (const c of _children) {
                    const _childMaxLevel = _countMaxLevel(c, (level || 1) + 1);

                    if (_childMaxLevel > f._childrenMaxLevel) {
                        f._childrenMaxLevel = _childMaxLevel;
                    };
                }

                return f._childrenMaxLevel;
            }





            if (_businessUnit) {
                for (const f of _businessUnit.Indicators) {
                    _countChildren(f);

                }
            }

            const _businessUnitSelector = () => {
                if (t.BusinessUnits.length > 1) {
                    return (<select data-mode="business_unit_selector" onChange={(e) => {
                        const _selectedValue = window.$(e.target).val();
                        for (var b of t.BusinessUnits) {
                            t.selected = t.Id == _selectedValue;
                        }
                        setTypes(utils.clone(types));
                    }}>
                        {t.BusinessUnits.map((b) => {
                            return (<option value={b.Id} selected={b.selected}>{b.Name}</option>);
                        })}
                    </select>);
                }
                else {
                    if (t.BusinessUnits.length == 1) {
                        return (<h6>{t.BusinessUnits[0].Code} {t.BusinessUnits[0].Name}</h6>)
                    }
                }
            }

            const _drawTable = (node) => {
                const _getChildNodes = (n) => {
                    const output = [n];
                    const _children = _businessUnit.Indicators.filter(x => x.Indicator.ParentId == n.Indicator.Id);
                    for (const c of _children) {
                        output.push(..._getChildNodes(c));
                    }

                    return output;
                }

                const _nodeData = _getChildNodes(node);

                let _data = _nodeData.filter(x => x._level == node._childrenMaxLevel)
                .sort((a, b) => { return a.Indicator.ItemOrder - b.Indicator.ItemOrder });

                for (const d of _data) {
                    let _current = d;
                    while (_current) {
                        if (_current.Indicator.ParentId) {
                            _current.parent = _nodeData.find(x => x.Indicator.Id == _current.Indicator.ParentId);
                            _current = _current.parent;
                        }
                        else {
                            _current = null;
                        }
                    }
                }

                for (const d of _data) {
                    d._uiOrder = 0;
                    let _current = d;
                    let _level = 0;
                    while (_current) {
                        d._uiOrder += _current.Indicator.ItemOrder * Math.pow(10, _level);
                        _current = _current.parent;
                        _level++;
                    }
                }

                _data = _data.sort((a, b) => { return a._uiOrder - b._uiOrder });

                const _drawTr = (r) => {
                    const _cells = [];
                    const _getLevel = (node, l) => {
                        if (node._level > l) {
                            return _getLevel(node.parent, l);
                        }
                        else {
                            return node;
                        }
                    }

                    const _drawPointOfAttention = (node) => {
                        const requirementList = [];

                        for (var r of node.Requirements) {
                            if (r.Requirement) {

                                requirementList.push(<><strong>{r.Requirement.Code}</strong> { r.Requirement.Name }<br></br></>);
                            }
                        }

                        return requirementList;
                    }

                    for (let level = 2; level <= r._level; level++) {
                        if (level == r._level
                            ||
                            _getLevel(r, level + 1).Indicator.ItemOrder == 0
                        ) {
                            const _node = _getLevel(r, level);
                            if (level == r._level) {
                                _cells.push(<td style={{ whiteSpace: "wrap" }}><p>{_drawPointOfAttention(_node)}</p></td>);
                            }
                            _cells.push(<td rowSpan={_node._childrenCount > 0 ? _node._childrenCount : 1} style={{ whiteSpace: "wrap" }} >
                                {level == r.level ? (<><a href={`/indicators/evaluation/${_node.Indicator.Id}`}>
                                    <i class="fa fa-pen-to-square"></i></a></>) : (null)}
                                <strong>{_node.Indicator.Code}</strong> {_node.Indicator.Name}</td>);


                        }
                    }

                    return (<tr>{_cells}</tr>)
                }

                const _drawHeader = () => {
                    const _levels = [];

                    for (let i = 1; i <= node._childrenMaxLevel; i++) {
                        _levels.push(`${levelLabels[i - 1]}`);
                    }

                    return (<tr>
                        {_levels.map((l) => {
                            return (<th>{l}</th>)
                        })}
                    </tr>);
                }
                return (
                    <table className="table">
                        <thead>
                            {_drawHeader()}
                        </thead>
                        <tbody>
                            {_data.map((r) => {
                                return _drawTr(r);
                            })}
                        </tbody>
                    </table>);
            }

            const _drawRootNode = (node, subLevel) => {


                var checkMaxLevel= _countMaxLevel(node);
                const _getTitle = () => {
                    if (subLevel == 1) {
                        return (<h6 className="accordion-header">
                            <button aria-expanded="false" data-bs-target={`#node_div_${node.Id}`} className="accordion-button collapsed" type="button" data-bs-toggle="collapse">
                                {node.Indicator.Code} {node.Indicator.Name}
                            </button>
                        </h6>);
                    }
                    else {
                        <h6>{node.Indicator.Code} {node.Indicator.Name}</h6>
                    }
                }

                return (<div className={subLevel == 1 ? "accordion-item" : null} data-bs-parent="accordion">
                    {_getTitle()}
                    <div id={`node_div_${node.Id}`} className={subLevel == 1 ? "accordion-collapse collapse" : null}>
                        {/* <div className="small container">
                            {node.Indicator.Name}
                            <hr></hr>
                        </div> */}
                        {
                            (node._childrenMaxLevel == 3) ? (_drawTable(node)) : (<>
                                {_businessUnit.Indicators.filter(x => x.Indicator.ParentId == node.Indicator.Id)
                                    .sort((a, b) => { return a.Indicator.ItemOrder - b.Indicator.ItemOrder })
                                    .map(x => _drawRootNode(x, subLevel + 1))
                                }
                            </>)
                        }
                    </div>

                </div>);
            }

            return (<div className={`tab-pane fade active ${t.selected ? "show" : ""}`} id={`tab-content-${t.Code}`} role="tabpanel" aria-labelledby={`#tab-content`}>
                <p class="lead">
                    {_businessUnitSelector()}
                </p>
                <div class="accordion">
                    {_rootNodes

                        .map((r) => {
                            return _drawRootNode(r, 1);
                        })}
                </div>
            </div>);
        }

        return (
            <><ul class="nav nav-tabs" id="classification-tabs" role="tablist">
                {types.map((t) => { return _drawTabHeader(t) })}
            </ul>
                <div class="tab-content" id="tabs-cmagari ontent" style={{ padding: 15 }}>
                    {types.map((t) => {
                        return _drawTabDiv(t)
                    }
                    )}
                </div>
            </>)
    }

    const _drawViewModeContent = () => {

        if (viewMode == "list") {
            return _drawTabs()

        } else if (viewMode == "edit") {
            return (

                <table className="table">
                    <thead>
                        <tr>
                            <th className="col-md-1" scope="col">#</th>
                            <th className="col-md-9">{t('name', { ns: 'labels' })}</th>
                            <th className="col-md-2">{t('action', { ns: 'labels' })}</th>
                        </tr>
                    </thead>
                    <tbody id="tBodyTable">
                        {drawMainNode()}
                    </tbody>
                </table>)
        }
        return (null)

    }

    return (
        <div className="d-flex flex-column" style={{ height: '100vh' }}>
            {/* HEADER + TOOLBAR (fixed, never scrolls) */}
            <header className="bg-white shadow-sm" style={{ position: 'sticky', top: 0, zIndex: 1000 }}>
                <div className="container-fluid d-flex justify-content-between align-items-center py-2 fixed-toolbar">
                    {/* breadcrumb navigation */}
                    <ol className="breadcrumb mb-0">
                    </ol>
                    
                    {/* action buttons */}
                    <div className="d-flex gap-3">
                        {_drawChangeMode()}

                        <Undo_Redo onInit={(r) => {
                            undo_redo = r;
                        }}
                            onChange={(d) => {
                                setData(d);
                            }}
                        ></Undo_Redo>
                        <a className="text-primary fs-13" onClick={(e) => {
                            _save();
                        }} role="button" title={t('saveData', { ns: 'labels' })}><i className="fa-solid fa-floppy-disk fa-2x"></i></a>
                    </div>
                </div>
            </header>

            {/* SCROLLABLE CONTENT AREA */}
            <main className="flex-grow-1 overflow-auto">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body p-0">
                                    <div className="tab-content" id="tabs-content" style={{ padding: 15 }}>
                                        {data ? (<>
                                            {_drawViewModeContent()}
                                            {editModal()}
                                        </>) : <div className="text-center"><img src={waiting} /></div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}

export { Indicators_Screen }